import {EventEmitter} from 'events'

import {v4 as uuid} from 'uuid'

import {PortalDefinition} from './Portal'

export class PortalWrangler {
  private emitter = new EventEmitter()
  private map = new Map<string, PortalDefinition[]>()

  public subscribe(poolId: string, cb: () => void): () => void {
    const callback = (): void => cb()

    this.emitter.addListener(poolId, callback)

    return () => {
      this.emitter.removeListener(poolId, callback)
    }
  }

  public createPool(): string {
    const id = uuid()
    this.map.set(id, [])
    return id
  }

  public destroyPool(poolId: string): void {
    this.map.delete(poolId)
    this.emitter.removeAllListeners(poolId)
  }

  public getPortals(poolId: string): PortalDefinition[] {
    return this.map.get(poolId) ?? []
  }

  public addPortal(poolId: string, portal: PortalDefinition): void {
    this.map.set(poolId, this.getPortals(poolId).concat(portal))
    this.emitter.emit(poolId)
  }

  public updatePortal(poolId: string, portal: PortalDefinition): void {
    this.map.set(
      poolId,
      this.getPortals(poolId).map((p) => {
        if (p.key === portal.key) return portal
        return p
      })
    )
    this.emitter.emit(poolId)
  }

  public removePortal(poolId: string, key: string): void {
    this.map.set(
      poolId,
      this.getPortals(poolId).filter((p) => p.key !== key)
    )
    this.emitter.emit(poolId)
  }
}
